import { IBuildConfiguration } from '../config/config.interface';

// eslint-disable-next-line @typescript-eslint/no-var-requires
const config = require('../config/config');

// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment: IBuildConfiguration = {
	...config,
	isProductionMode: true,
	installedModules: null,
};
